import React, { useEffect, useRef, useState } from 'react';
import { Container, Graphics } from '@pixi/react';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';

import { gameResourcesService } from '../../../services/gameResourcesService';

const columns = [0, 1, 2, 3, 4];
function ExpandWild({ containerConfig }) {
  const [mask, setMask] = useState(null);
  const expandWildRef = useRef(null);

  useEffect(() => {
    const expandWilds = columns.map((_, index) => {
      const expandWild = new Spine({ key: '9' });
      expandWild.columnIndex = index;
      expandWild.x = index * (isMobile() ? 104 : 173);
      expandWildRef.current.addChild(expandWild);
      return expandWild;
    });
    gameResourcesService.setExpandWildSpine(expandWilds);
  }, [expandWildRef]);

  useEffect(() => {
    if (expandWildRef.current) {
      expandWildRef.current.mask = mask;
    }
  }, [mask, expandWildRef]);

  return (
    <Container {...containerConfig} ref={expandWildRef} name='ExpandWildContainer'>
      {isMobile() ? (
        <Graphics
          draw={(g) => {
            g.beginFill(0xff700b);
            g.drawRect(-50, -45, 520, 318);
          }}
          ref={(graphicsRef) => setMask(graphicsRef)}
        />
      ) : (
        <Graphics
          draw={(g) => {
            g.beginFill(0xff700b);
            g.drawRect(-85, -66, 890, 515);
          }}
          ref={(graphicsRef) => setMask(graphicsRef)}
        />
      )}
    </Container>
  );
}

export default ExpandWild;
